export const profile_update = (data) => {
    return {
        type: 'PROFILE_UPDATE',
        user: data.user,
    }
}
